"use client";

import { createContext, useContext, useState, useMemo, useCallback } from "react";
import {
  markCityAsUserSelectedClient,
  setSelectedCityClient,
} from "@helpers/client/getSelectedCity";
import { City } from "@components/organisms/CitySelectionModal/City.types";
import { defaultCity } from "@constants/cities";



const CityContext = createContext<{
  city: City;
  setCity: (city: City) => void;
  syncDetectedCity: (city: City) => void;
}>({ city: defaultCity, setCity: () => {}, syncDetectedCity: () => {} });

export function CityProvider({ children, selectedCity }: { children: React.ReactNode, selectedCity: City }) {
  const [city, setCityState] = useState<City>(selectedCity || defaultCity);

  const persistCity = useCallback((newCity: City) => {
    void setSelectedCityClient({
      id: newCity?.id || defaultCity.id,
      name: newCity?.name || defaultCity.name,
      slug: newCity?.city_slug || defaultCity.city_slug,
    });
  }, []);

  const changeCity = useCallback((newCity: City) => {
    persistCity(newCity);
    void markCityAsUserSelectedClient();
    setCityState(newCity);
  }, [persistCity]);

  const syncDetectedCity = useCallback((newCity: City) => {
    persistCity(newCity);
    setCityState(newCity);
  }, [persistCity]);

  const value = useMemo(
    () => ({ city, setCity: changeCity, syncDetectedCity }),
    [city, changeCity, syncDetectedCity]
  );

  return <CityContext.Provider value={value}>{children}</CityContext.Provider>;
}

export function useCity() {
  return useContext(CityContext);
}
